export const pagination = {
  name: null,
  items_per_page: 10,
  page: 1,
}
